import { CONSTANT } from '@const';
import { ActionablePhoto } from '@moduleAForm';
import { FileUploadStatus, Photo, UpdateAction, UpdatePhoto } from '@types';
import { FileUploadItem } from '@utils';

import { Mapper } from './Mapper';

export class PhotoMapper extends Mapper<ActionablePhoto | FileUploadItem, Photo, UpdatePhoto> {
	public mapToForm(data: Photo): FileUploadItem {
		return {
			id: data.id,
			file: undefined,
			filename: data.filename,
			base64: undefined,
			fileLocation: data.fileLocation,
			uploadStatus: {
				status: FileUploadStatus.RESTORED,
				fileuri: data.fileUri,
				contactid: undefined,
			},
			error: undefined,
			action: UpdateAction.NONE,
		};
	}

	public mapFormToPayload(data: {
		formValue: FileUploadItem;
		subject: number;
		number: number;
	}): UpdatePhoto {
		return {
			Photo: {
				id: data.formValue?.id ?? CONSTANT.INVALID_UUID,
				filename: data.formValue?.filename ?? data.formValue?.file?.name,
				number: data.number,
				subject: data.subject,
				fileUri: data.formValue?.uploadStatus?.fileuri ?? undefined,
				fileLocation: data.formValue?.fileLocation,
			},
			action: data.formValue?.action || UpdateAction.NONE,
		};
	}

	public mapModelToPayload(data: Photo): UpdatePhoto {
		return {
			Photo: data,
			action: UpdateAction.NONE,
		};
	}

	public mapToFormList(dataList: Photo[]): FileUploadItem[] {
		return dataList.map(this.mapToForm);
	}
}
